export function formatMoney(value: unknown) {
  if (value === null || value === undefined || value === '') return '—'
  const amount = Number(value)
  if (Number.isNaN(amount)) return String(value)
  return new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)
}

export function formatPercent(value: unknown) {
  if (value === null || value === undefined || value === '') return '—'
  const amount = Number(value)
  if (!Number.isFinite(amount)) return String(value)
  return `${new Intl.NumberFormat('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)}%`
}

export function formatDate(value: unknown, options: Intl.DateTimeFormatOptions = {}) {
  if (!value) return '—'
  const date = new Date(String(value))
  if (Number.isNaN(date.getTime())) return String(value)
  return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', ...options }).format(date)
}

export function formatTime(value: unknown) {
  if (!value) return ''
  const date = new Date(String(value))
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit' }).format(date)
}

export function formatVisitDateTime(value: unknown) {
  return formatDate(value, { timeZone: 'Europe/Lisbon', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' })
}

export function humanize(value: unknown) {
  if (value === null || value === undefined || value === '') return '—'
  return String(value)
    .replace(/[_-]/g, ' ')
    .replace(/(^|\s)(\p{L})/gu, (_match, prefix: string, letter: string) => `${prefix}${letter.toLocaleUpperCase()}`)
}

export function initials(value: unknown) {
  return String(value || 'TV')
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase()
}

export function isOverdue(value: unknown) {
  if (!value) return false
  const date = new Date(String(value))
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return date < today
}

export function classNames(...values: Array<string | false | null | undefined>) {
  return values.filter(Boolean).join(' ')
}
